import React, { useState } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Form,
	Input,
	FormGroup,
	Col,
	Label,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { editProfile } from '../../store/actions/business';
import './index.css';
function ContactEditModal(props) {
	const [modal, setModal] = useState(false);
	const toggle = () => setModal(!modal);

	const dispatch = useDispatch();
	const { id } = useSelector((state) => state.currentUser.user);

	const [phone, setPhone] = useState(props.valuePhone || '');
	const [website, setWebsite] = useState(props.valueWebsite || '');

	const handleSubmit = (e) => {
		e.preventDefault();
		dispatch(editProfile(id, { phone, website }));
		setModal(false);
	};

	const { valuePhone, valueWebsite } = props;

	return (
		<div>
			<Button className='cta-pill-btn ml-2' onClick={toggle}>
				<i className='nc-icon nc-settings-gear-65 mr-1' />
				Edit
			</Button>

			<Modal isOpen={modal} toggle={toggle} centered>
				<ModalHeader toggle={toggle}>Add your contact information</ModalHeader>

				<ModalBody>
					<Form onSubmit={handleSubmit}>
						<FormGroup row>
							<Label for='phone' sm={3}>
								Phone
							</Label>
							<Col sm={9}>
								<Input
									type='text'
									id='phone'
									name='phone'
									onChange={(e) => setPhone(e.target.value)}
									value={phone}
									placeholder={valuePhone || 'Add phone number'}
								/>
							</Col>
						</FormGroup>

						<FormGroup row>
							<Label for='website' sm={3}>
								Website
							</Label>
							<Col sm={9}>
								<Input
									type='text'
									id='website'
									name='website'
									onChange={(e) => setWebsite(e.target.value)}
									value={website}
									placeholder={valueWebsite || 'Add website URL'}
								/>
							</Col>
						</FormGroup>

						<Button className='cta-pill-btn w-100' type='submit'>
							Save Changes
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</div>
	);
}

export default ContactEditModal;
